<template>
  <div class="utente">
    Nome:
    <b-form-input v-model="utente.nome" placeholder="Nome"></b-form-input>
    Cognome:
    <b-form-input v-model="utente.cognome" placeholder="Cognome"></b-form-input>
    PEC:
    <b-form-input v-model="utente.pec" placeholder="PEC"></b-form-input>
    Email utente:
    <b-form-input v-model="utente.emailUtente" placeholder="Email Utente"></b-form-input>
    
    Denominazione:
    <b-form-input v-model="utente.denominazione" placeholder="Denominazione"></b-form-input>
    Indirizzo:
    <b-form-input v-model="utente.indirizzo" placeholder="Indirizzo"></b-form-input>
    Città:
    <b-form-input v-model="utente.citta" placeholder="Città"></b-form-input>
    CAP:
    <b-form-input v-model="utente.cap" placeholder="CAP"></b-form-input>
    Provincia:
    <b-form-input v-model="utente.provincia" placeholder="Provincia"></b-form-input>
    Email pagante:
    <b-form-input v-model="utente.emailPagante" placeholder="Email pagante"></b-form-input>
    Codice fiscale pagante:
    <b-form-input v-model="utente.codFiscPagante" placeholder="Codice fiscale pagante"></b-form-input>
    Partita IVA:
    <b-form-input v-model="utente.piva" placeholder="Partita IVA"></b-form-input>
    Corrispettivo:
    <b-form-input v-model="utente.corrispettivo" placeholder="Corrispettivo"></b-form-input>

    Data scadenza:
    <b-form-input v-model="utente.dataScadenza" placeholder="Data scadenza"></b-form-input>
    Codice Fatturazione Elettronica:
    <b-form-input v-model="utente.codiceUfficio" placeholder="Codice Fatturazione Elettronica"></b-form-input>
    <br/>
    <b-form-checkbox v-model="utente.fatturaDaEmettere" switch>
      Fattura da emettere
    </b-form-checkbox>
    <br/>

    <b-button @click="aggiorna()">Aggiorna</b-button>
  </div>
</template>

<script>
import services from '../../services/service.js'


export default {
  name: 'utente',
  data () {
    return {
        utente: {
            nome: '',
            cognome: '',
            pec: '',
            emailUtente: '',
            denominazione: '',
            indirizzo: '',
            citta: '',
            cap: '',
            provincia: '',
            emailPagante: '',
            codFiscPagante: '',
            piva: '',
            corrispettivo: '',
            dataScadenza: '',
            codiceUfficio: '',
            fatturaDaEmettere: false,
        }
    }
  },
  methods: {
    getData() {
        let userId = this.$route.params.userId;
        services.execute('get', 'utente/admin/' + userId).then((data) => {
          this.utente = data;
        });
    },
    aggiorna() {
        let userId = this.$route.params.userId;
        services.execute('put', 'utente/admin/' + userId, this.utente).then((data) => {
          this.utente = data;
          
          this.$router.push({name: "GestioneUtenti"});
        });
    }
  },
  mounted() {
    this.getData();

    this.$parent._data.loaded = true;
  }
}
</script>

<style>
.utente {
    text-align: center;
    padding-left: 20%;
    padding-right: 20%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/ModificaUtente.vue